// Shared derivation of "can the contact register for the next exam right now",
// used by VerificationForm (/erstpruefung, /erneute-pruefung) and Orders alike.
// Mirrors the backend checks in external_api::postVerification / OrderService.

export interface IExamInfo {
    exam_date:number,
    registration_deadline:number,
    // Deadline day inclusive, see OrderService::isRegistrationOpen. Older
    // backends omit it; then the deadline is evaluated client-side.
    registration_open?:boolean,
    // One registration per exam project; missing on older backends.
    allowed_exam_types?:string[],
    linked_exam_number?:string|null,
}

export type ExamRegistrationStatus =
    | 'loading'
    | 'no_exam'
    | 'deadline_passed'
    | 'already_registered'
    | 'open';

export const isRegistrationOpen = (info:IExamInfo):boolean => {
    if (typeof info.registration_open === 'boolean') {
        return info.registration_open;
    }
    const deadline = Number(info.registration_deadline) || 0;
    if (deadline <= 0) {
        return true;
    }
    // Deadline is stored as the start of its day; the whole day still counts.
    return Math.floor(Date.now() / 1000) < deadline + 24 * 60 * 60;
};

/**
 * @param info   Parsed nextExam payload; null means no upcoming exam project.
 * @param loaded Whether the request has finished (success or failure).
 * @param failed Request failed: fail open, the backend refuses a submit anyway.
 */
export const getExamRegistrationStatus = (info:IExamInfo|null|undefined, loaded:boolean, failed:boolean):ExamRegistrationStatus => {
    if (!loaded) {
        return 'loading';
    }
    if (failed) {
        return 'open';
    }
    if (!info || typeof info !== 'object') {
        return 'no_exam';
    }
    if (Array.isArray(info.allowed_exam_types) && info.allowed_exam_types.length === 0) {
        return 'already_registered';
    }
    if (!isRegistrationOpen(info)) {
        return 'deadline_passed';
    }
    return 'open';
};
